// extracted by mini-css-extract-plugin
export default {"wrapperStyle":"RateConfig_wrapperStyle__OtI1Y","form":"RateConfig_form__fjXH7"};